import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/image/29.png';
const _hoisted_1 = {
  class: "comp_certification"
};
const _hoisted_2 = {
  class: "type"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "des"
};
const _hoisted_5 = {
  key: 0,
  class: "store_type"
};
const _hoisted_6 = {
  class: "btn_list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 1,
  class: "store_type"
};
const _hoisted_9 = {
  class: "btn_list"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  key: 2,
  class: "store_type"
};
const _hoisted_12 = {
  class: "btn_list"
};
const _hoisted_13 = ["onClick"];
import { ref, computed, onMounted } from 'vue';
import TableTwo from '@/components/tableTwo.vue';
import { typeList1, enterTypeList1, storeTypeList1, storeTypeList2, storeTypeList3, meritoTypeList1, meritoTypeList2, tableDataOne1, tableDataOne2, tableDataOne3, tableDataTwo1, tableDataTwo2, tableDataTwo3, tableDataTwo4, tableDataTwo5, tableDataTwo6, tableDataThree1 } from "./certification_json.js";

// 定义常量，避免魔法数字
const TYPE_PERSONAL = 1;
const TYPE_ENTERPRISE = 2;
const ENTER_TYPE_NORMAL = 1;
const ENTER_TYPE_TRADE = 2;

// 状态管理

export default {
  __name: 'certification',
  setup(__props) {
    const type = ref(TYPE_PERSONAL);
    const enterType = ref(null);
    const storeType = ref(1);
    const meritoType = ref(null);

    // 数据列表
    const typeList = ref(typeList1);
    const enterTypeList = ref(enterTypeList1);
    const storeTypeList = ref(storeTypeList1);
    const meritoTypeList = ref([]);

    // 表格数据
    const tableDataOne = ref(tableDataOne1);
    const tableDataTwo = ref([]);
    const tableDataThree = ref([]);

    // 计算属性
    const currentDes = computed(() => {
      return typeList.value.find(item => item.id === type.value)?.des || '';
    });

    // 初始化
    onMounted(() => {
      // 设置初始状态
      resetState();
    });

    // 重置状态
    const resetState = () => {
      if (type.value === TYPE_PERSONAL) {
        enterType.value = null;
        enterTypeList.value = [];
        storeType.value = 2;
        storeTypeList.value = storeTypeList1;
        meritoType.value = null;
        meritoTypeList.value = [];
        tableDataOne.value = tableDataOne2;
      } else {
        enterType.value = ENTER_TYPE_NORMAL;
        enterTypeList.value = enterTypeList1;
        storeType.value = 3;
        storeTypeList.value = storeTypeList2;
        meritoType.value = 1;
        meritoTypeList.value = meritoTypeList1;
        tableDataOne.value = tableDataOne3;
      }
      tableDataTwo.value = [];
      tableDataThree.value = [];
    };

    // 头部tab切换
    const typeChange = id => {
      if (id === type.value) return;
      type.value = id;
      resetState();
    };

    // 入驻类型切换
    const enterChange = id => {
      if (id === enterType.value) return;
      enterType.value = id;

      // 更新店铺类型
      storeType.value = id === ENTER_TYPE_NORMAL ? 3 : 4;
      storeTypeList.value = id === ENTER_TYPE_NORMAL ? storeTypeList2 : storeTypeList3;

      // 更新主营类目
      meritoType.value = id === ENTER_TYPE_NORMAL ? 1 : null;
      meritoTypeList.value = id === ENTER_TYPE_NORMAL ? meritoTypeList1 : [];

      // 更新表格数据
      tableDataOne.value = tableDataOne3;
      tableDataTwo.value = id === ENTER_TYPE_NORMAL ? [] : tableDataTwo3;
      tableDataThree.value = id === ENTER_TYPE_NORMAL ? [] : tableDataThree1;
    };

    // 店铺类型切换
    const storeChange = id => {
      if (id === storeType.value) return;
      storeType.value = id;

      // 更新主营类目
      updateMeritoType(id);

      // 更新表格数据
      updateTableData(id);
    };

    // 更新主营类型
    const updateMeritoType = storeId => {
      if (storeId === 3) {
        meritoType.value = 1;
        meritoTypeList.value = meritoTypeList1;
      } else if (enterType.value === ENTER_TYPE_NORMAL && [5, 6, 7].includes(storeId)) {
        meritoType.value = 2;
        meritoTypeList.value = meritoTypeList2;
      } else {
        meritoType.value = null;
        meritoTypeList.value = [];
      }
    };

    // 更新表格数据
    const updateTableData = storeId => {
      // 更新主体资质表格
      if (storeId === 1) {
        tableDataOne.value = tableDataOne1;
      } else if (storeId === 2) {
        tableDataOne.value = tableDataOne2;
      } else {
        tableDataOne.value = tableDataOne3;
      }

      // 更新品牌资质表格
      if (storeId === 4) {
        tableDataTwo.value = tableDataTwo3;
      } else if (enterType.value === ENTER_TYPE_NORMAL) {
        if (storeId === 5) {
          tableDataTwo.value = tableDataTwo1;
        } else if ([6, 7].includes(storeId)) {
          tableDataTwo.value = tableDataTwo2;
        } else {
          tableDataTwo.value = [];
        }
      } else if (enterType.value === ENTER_TYPE_TRADE) {
        if (storeId === 5) {
          tableDataTwo.value = tableDataTwo4;
        } else if (storeId === 6) {
          tableDataTwo.value = tableDataTwo5;
        } else if (storeId === 7) {
          tableDataTwo.value = tableDataTwo6;
        } else {
          tableDataTwo.value = [];
        }
      } else {
        tableDataTwo.value = [];
      }

      // 更新采购凭证表格
      if (storeId === 4 || storeId === 7 && enterType.value === ENTER_TYPE_TRADE) {
        tableDataThree.value = tableDataThree1;
      } else {
        tableDataThree.value = [];
      }
    };

    // 主营类目切换
    const meritoChange = id => {
      if (id === meritoType.value) return;
      meritoType.value = id;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "title"
      }, "资质要求", -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['btns', {
            checked: type.value === item.id
          }]),
          onClick: $event => typeChange(item.id)
        }, _toDisplayString(item.name), 11, _hoisted_3);
      }), 128)), _createElementVNode("div", _hoisted_4, _toDisplayString(currentDes.value), 1)]), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "hint"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }), _createElementVNode("span", null, "快速筛选入注资质，不同店铺类型，入驻所需资质不同，请根据您的实际情况进行选择")], -1)), enterTypeList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "store_type_title"
      }, "入驻类型", -1)), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(enterTypeList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['btns', {
            checked: enterType.value === item.id
          }]),
          onClick: $event => enterChange(item.id)
        }, _toDisplayString(item.name), 11, _hoisted_7);
      }), 128))])])) : _createCommentVNode("", true), storeTypeList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "store_type_title"
      }, "店铺类型", -1)), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeTypeList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['btns', {
            checked: storeType.value === item.id
          }]),
          onClick: $event => storeChange(item.id)
        }, _toDisplayString(item.name), 11, _hoisted_10);
      }), 128))])])) : _createCommentVNode("", true), meritoTypeList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "store_type_title"
      }, "主营类型", -1)), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meritoTypeList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['btns', {
            checked: meritoType.value === item.id
          }]),
          onClick: $event => meritoChange(item.id)
        }, _toDisplayString(item.name), 11, _hoisted_13);
      }), 128))])])) : _createCommentVNode("", true), tableDataOne.value.length ? (_openBlock(), _createBlock(TableTwo, {
        key: 3,
        name: "主体资质",
        data: tableDataOne.value
      }, null, 8, ["data"])) : _createCommentVNode("", true), tableDataTwo.value.length ? (_openBlock(), _createBlock(TableTwo, {
        key: 4,
        name: "品牌资质",
        data: tableDataTwo.value
      }, null, 8, ["data"])) : _createCommentVNode("", true), tableDataThree.value.length ? (_openBlock(), _createBlock(TableTwo, {
        key: 5,
        name: "采购凭证",
        data: tableDataThree.value
      }, null, 8, ["data"])) : _createCommentVNode("", true)]);
    };
  }
};